import {Photo, PhotoToken} from './requesters/Photo';
import {Video, VideoToken} from './requesters/Video';
import {CommandRequester} from '../../../CommandRequester';

/**
 * Commands for working with Jibo's media
 * @namespace CommandRequester.media
 */
export class Media {

    /**
     * Commands for capturing media from Jibo's cameras
     * @namespace CommandRequester.media.capture
     */
    capture: Capture;

    constructor(requester) {
        this.capture = new Capture(requester);
    }
}

export class Capture {

    photoRequest: Photo;
    videoRequest: Video;

    constructor(requester: CommandRequester) {
        this.photoRequest = new Photo(requester);
        this.videoRequest = new Video(requester);
    }

    /**
     * Take a photo
     * @method CommandRequester.media.capture#photo
     * @param  {CommandRequester.media.Camera} [camera=left] Which camera to use
     * @param  {CommandRequester.media.CameraResolution} [resolution=low] Choose a resolution.
     * @param  {boolean} [distortion=true] `false` for fisheye lense.
     * @return {PhotoToken}
     */
    public photo(
        camera: CommandRequester.media.Camera = CommandRequester.media.Camera.left,
        resolution: CommandRequester.media.CameraResolution = CommandRequester.media.CameraResolution.low,
        distortion: boolean = true,
    ): PhotoToken {
        const cameraType = CommandRequester.media.Camera[camera];
        const protocol = Photo.generateProtocol(cameraType, resolution, distortion);
        return this.photoRequest.generateToken(protocol, true) as PhotoToken;
    }

    /**
     * Stream what Jibo currently sees
     * @method CommandRequester.media.capture#video
     * @param  {CommandRequester.media.VideoType} [videoType=normal] Choose a video type
     * @param  {number} [duration=0] How long to stream for. Currently unsupported. Call `cancel()` to stop streaming
     * @return {VideoToken}
     */
    public video(
        videoType: CommandRequester.media.VideoType = CommandRequester.media.VideoType.normal,
        duration: number = 0,
    ): VideoToken {
        const protocol = Video.generateProtocol(videoType, duration);
        return this.videoRequest.generateToken(protocol, true);
    }
}